<template>
  <div>

    <h3>Call Taker Stats</h3>
    <div v-if="callStore.toCalls.length > 0">
      <table style="width:500px">
        <tr>
          <th>Phone</th>
          <th>Calls</th>
          <th>Completed</th>
          <th>No Answer</th>
          <th>Busy</th>
          <th>Missed Calls %</th>
        </tr>
        <tr v-for="call in callStore.toCalls" :key="call.callTaker">
          <td>{{$util.formatPhoneNumber(call.callTaker)}}</td>
          
          <td>{{call.calls.length}}</td>
          <td>
            <transition name="data" mode="out-in">
              <span :key="callStore.numberOfCalls(call.calls)">
                {{call.calls.filter(r=>r.status==="completed").length}}
              </span>
            </transition>
          </td>

          <td>{{call.calls.filter(r=>r.status==="no-answer").length}}</td>
          <td>{{call.calls.filter(r=>r.status==="busy").length}}</td>
          
          <td>{{percentBusy(call) }}</td>
          
        </tr>
      </table>
      <button @click="callStore.showCalls=!callStore.showCalls">{{callStore.showCalls ? 'Hide' : 'Show'}} Calls</button>
      <button @click="callStore.showCalls=!callStore.showCalls">{{callStore.showCalls ? 'Hide' : 'Show'}} Calls</button>
      <button @click="callStore.showDebugCalls=!callStore.showDebugCalls">{{callStore.showDebugCalls ? 'Hide' : 'Show' | percent}} Debug Calls</button>
    </div>
    <div v-else>...Loading</div>

    <h3>Call Stats</h3>
    <div v-if="callStore.fromCalls.length > 0">
      <table style="width:500px">
        <tr>
          <th>Phone</th>
          <th>Calls</th>
          <th>Completed</th>
          <th>No Answer</th>
          <th>Busy</th>
        </tr>
        <tr v-for="call in callStore.fromCalls.slice(0, 10)" :key="call.phoneFrom">
          <td>{{$util.formatPhoneNumber(call.phoneFrom)}}</td>
          <td>{{call.calls.length}}</td>
          <td>{{call.calls.filter(r=>r.status==="completed").length}}</td>
          <td>{{call.calls.filter(r=>r.status==="no-answer").length}}</td>
          <td>{{call.calls.filter(r=>r.status==="busy").length}}</td>
        </tr>
        <tr><td>...</td></tr>
      </table>
    </div>

    <div v-if="callStore.showCalls">
      <h3>Raw Calls</h3>
      <div v-if="callStore.calls.length > 0">
        
        <table style="width:500px">
          <tr>
            <th>date</th>
            <th>date</th>
            <th>id</th>
            <th>From</th>
            <th>to</th>
            <th>direction</th>
            <th>status</th>
            <th>price</th>
            <th></th>
          </tr>
          <tr v-for="call in callStore.calls" :key="call.sid">
            <td>{{$util.d(call.dateCreated)}}</td>
            <td>{{$util.d(call.dateUpdated)}}</td>
            <td><a :href="`https://www.twilio.com/console/voice/calls/logs/${call.sid}`" target="_blank">{{call.sid}}</a> ↗︎</td>
            <td>{{$util.formatPhoneNumber(call.from)}}</td>
            <td>{{$util.formatPhoneNumber(call.to)}}</td>
            <td>{{call.direction}}</td>
            <td>{{call.status}}</td>
            <td>{{call.price}}</td>
          </tr>
        </table>
      </div>
      <div v-else>...Loading</div>
    </div>

    <div v-if="callStore.showDebugCalls">
      <BasicTableComponent :list="callStore.calls" />
    </div>
  </div>
</template>

<script>
export default {
  data () { return {

  }},
  inject: ['phonePage'],
  computed: {
    callStore: function(){
      return this.phonePage.$refs.callStore
    },
  },
  mounted: async function(){
    
  },
  methods: {
    percentBusy(call){
      console.log(parseFloat(call.calls.filter(r=>r.status==="no-answer").length) / parseFloat(call.calls.length), parseFloat(call.calls.filter(r=>r.status==="busy").length) , parseFloat(call.calls.length))
      return numeral(parseFloat(call.calls.filter(r=>r.status==="no-answer").length) / parseFloat(call.calls.length)).format('0.0%')
    }
  },
  filters:{
    percent(val){
      numeral(val).format('0.0%')
    },
  }
}
</script>

<style scoped>

</style>